<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          任务中心
          <span class="titleColor"></span> -任务列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <!-- 检索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="任务名称">
          <el-input v-model="listQuery.taskName" placeholder="任务名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="任务编号">
          <el-input v-model="listQuery.taskNo" placeholder=" " clearable></el-input>
        </el-form-item>
        <el-form-item label="线索编号">
          <el-input v-model="listQuery.clueNo" placeholder=" " clearable></el-input>
        </el-form-item>
        <el-form-item label="城市">
          <el-select v-model="listQuery.cityId" style="width:150px" clearable placeholder="请选择城市" filterable>
            <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
              :value="item.id + ''"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="查询范围">
          <el-select v-model="listQuery.isSelf" style="width:150px" clearable placeholder="查询范围" filterable>
            <el-option label="所有任务" :value="0"></el-option>
            <el-option label="我的任务" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="listQuery.taskType" clearable class="filter-item" placeholder="请选择">
            <el-option label="线索任务" value="1" />
            <el-option label="面试任务" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="listQuery.state" clearable placeholder="请选择状态" filterable>
            <el-option v-for="(item, index) in stateMap" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="是否启用">
          <el-select v-model="listQuery.deleted" class="filter-item" placeholder="是否启用">
            <el-option label="启用" value="false" />
            <el-option label="停用" value="true" />
          </el-select>
        </el-form-item>-->

        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>

      </el-form>

      <!-- 表单 -->
      <el-table :data="listData" border class="table">
        <el-table-column prop="id" width="80" label="id" fixed></el-table-column>
        <el-table-column prop="taskNo" label="任务编号"></el-table-column>
        <el-table-column prop="taskName" label="任务名称"></el-table-column>
        <el-table-column prop="cityName" label="城市"></el-table-column>

        <el-table-column prop="type" label="任务类型">
          <template slot-scope="scope">
            <span v-if="scope.row.taskType == 1">线索任务</span>
            <span v-if="scope.row.taskType == 2">面试任务</span>
          </template>
        </el-table-column>
        <el-table-column prop="clueNo" label="线索编号"></el-table-column>
        <el-table-column prop="workerNo" label="服务者编号"></el-table-column>
        <el-table-column prop="workerName" label="服务者姓名"></el-table-column>
        <el-table-column prop="isOpen" label="状态">
          <template slot-scope="scope">
            {{ stateMap[scope.row.state - 1].label }}
          </template>
        </el-table-column>

        <el-table-column prop="timeout" label="超时时间" :formatter="dateFormat">

        </el-table-column>

        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
        <!-- <el-table-column prop="updateTime" label="修改时间" :formatter="dateFormat"></el-table-column> -->
        <el-table-column prop label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-view" @click="handleDetail(scope.row)">操作详情</el-button>
            <!-- <el-button type="text" icon="el-icon-edit" @click="editTaskConfig(scope.row)">编辑</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />




    </div>
  </div>
</template>
<script>
import moment from "moment";
import workercrmapi from "@/script/api/workercrmapi";
import wmsApi from "@/script/api/wmsApi";
import taskApi from "@/script/api/taskApi";
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data";
import service from "@/script/api/service";
export default {
  components: { Pagination },
  data() {
    return {
      stateMap: [{ value: 1, label: "待分配" },
      { value: 2, label: "处理中" },
      { value: 3, label: "处理完成" },
      { value: 4, label: "取消" },
      ],
      cityList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      listData: [],
      listQuery: {
        cityId: '',
        taskType: '',
        taskName: '',
        state: '',
        taskNo: '',
        clueNo: '',
        isSelf:0,
        userId:globalData.userInfo.id
      },


    };
  },
  created() {
    this.querySearch();
    this.getAllCity();

  },
  methods: {
    //查询
    querySearch() {
      let params = this.listQuery;
      params.pageNum = this.currentPage;
      params.pageSize = this.pageSize;
      taskApi
        .$axiosWorkerTaskPageList(params)
        .then(res => {
          console.log(res);
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/taskCenter/taskDetail",
        query: {
          taskNo: row.taskNo,
        },
      });
    },


    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity().then(res => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },




    //时间格式化
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined || date == "") {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm");
    }
  }
};
</script>
<style scoped>
.el-form {
  padding: 0 60px 0 20px !important;
}

.el-select.el-select--small,
.el-input--small {
  width: 100%;
}
</style>

